'use client';
import { FormProvider } from 'react-hook-form';
import AddressInformation from './guest-information-form/AddressInformation';
import ContactInformation from './guest-information-form/ContactInformation';
import { GuestInformationFormType } from './guest-information-form/types';

export const GuestInformationForm = ({
  addressLine2Isrequired = '',
  countries = [],
  id,
  formMethods,
  className,
  onSubmit,
  t
}: GuestInformationFormType) => {
  return (
    <FormProvider {...formMethods}>
      <form
        id={id}
        data-testid="guest-info-form"
        className={className}
        onSubmit={formMethods.handleSubmit((data) => {
          if (onSubmit) {
            onSubmit(data);
          }
        })}
      >
        <AddressInformation
          countries={countries}
          addressLine2Isrequired={addressLine2Isrequired}
          t={t}
        />
        <ContactInformation countries={countries} t={t} />
      </form>
    </FormProvider>
  );
};
